import React, { FC } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router';
import AdminReportcounters from './admin-report-counters';
import AdminReportCountersMobile from './admin-report-counters-tw';
import AdminReportAuditLogsList from './admin-report-audit-logs-list';
import AdminReportAuditLogsListMobile from './admin-report-audit-logs-list-tw';
import './admin-reports-landing-page.less';
import { useWindowSize } from 'utils/useWindowSize';

export interface AdminReportsLandingPageProps extends RouteComponentProps, WithTranslation {}

const AdminReportsLandingPage: FC<AdminReportsLandingPageProps> = props => {
  const { width } = useWindowSize();
  const isMobile = width < 768;

  return isMobile ? (
    <>
      <h3>{''}</h3>
      <AdminReportCountersMobile {...props} />
      <AdminReportAuditLogsListMobile {...props} />
    </>
  ) : (
    <>
      <h3>{''}</h3>
      <AdminReportcounters {...props} />
      <AdminReportAuditLogsList {...props} />
    </>
  );
};

export default withTranslation()(AdminReportsLandingPage);
